const captions: Record<string, string> = {
  gate: 'Plan of a guarded gate: fence line, guard post and the swing of the barrier',
  response: 'Plan of a response route from the road to a monitored building',
  camera: 'Plan of a camera position and its field of view across a fence line',
  medical: 'Floor plan marking a first aid assembly point',
  fire: 'Floor plan marking six extinguisher positions and the escape route',
  training: 'Plan of a training room laid out for an intake of twenty-four',
};

/**
 * The signature device: a drawn plan fragment, one per service line.
 *
 * Six variants live as static files in `public/tiles/`. They were inline SVG
 * until hydrating roughly a hundred extra nodes started showing up as blocking
 * time; as images they cost nothing to hydrate, cache on their own, and load
 * lazily below the fold.
 */
export function PerimeterTile({ plan }: Props) {
  return (
    <img
      src={`/tiles/${plan}.svg`}
      alt={captions[plan] ?? 'Drawn site plan'}
      // Matches the intrinsic size declared on the files themselves. Without one
      // the browser resolves an SVG that carries only a viewBox against the
      // 300x150 default object size and every tile reads as an upscale.
      width={240}
      height={240}
      loading="lazy"
      decoding="async"
      className="h-full w-full"
    />
  );
}

interface Props {
  plan: string;
}
